// extracted by css-extract-rspack-plugin
export default {"field":"field-LxgjvH","label":"label-DOJdH1","input":"input-w_nAOb","hint":"hint-krWcLF","error":"error-og6EJ1"};